import React, { useContext } from 'react'
import { usePathname } from 'next/navigation'

import { trackClickDateButton } from 'app/components/shared/Analytics/segment'
import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import { DateTimePickerContextType, VisibleSectionEnum } from 'components/form/DateTimePicker/interfaces'

import { useAllDayHelpers } from './helpers'
import { DayNumber, DayStyleProps, StyledButton } from './styles'

type Props = {
  index: number
}

type MemoizedDayContentProps = Props &
  Pick<DateTimePickerContextType, 'setDateTimeState'> & {
    pathname: string
    month: number
    year: number
  }

const MemoizedDayContent: React.FC<MemoizedDayContentProps> = React.memo(function MemoizedDayContent({
  pathname,
  month,
  year,
  index,
  setDateTimeState,
}) {
  const { isToday, isSelected, isDisabled } = useAllDayHelpers(index)

  const handleDateClick = () => {
    trackClickDateButton({ day: index + 1, month: month, year: year }, pathname ?? '')

    setDateTimeState((state) => ({
      ...state,
      value: { ...state.value, month, year, day: index + 1, time: undefined },
      visibleSection: VisibleSectionEnum.TIME,
    }))
  }

  const stylingProps: DayStyleProps = {
    isSelected,
    isToday,
    isDisabled,
  }

  return (
    <StyledButton onClick={handleDateClick} {...stylingProps}>
      <DayNumber fontSize="sm" {...stylingProps}>
        {index + 1}
      </DayNumber>
    </StyledButton>
  )
})

export const Day: React.FC<Props> = ({ index }) => {
  const pathname = usePathname()

  const { dateTimeState, setDateTimeState } = useContext(DateTimePickerContext)
  const { month, year } = dateTimeState.datePicker

  return (
    <MemoizedDayContent
      month={month}
      year={year}
      setDateTimeState={setDateTimeState}
      index={index}
      pathname={pathname ?? ''}
    />
  )
}
